let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fzXBH")).then(() => parcelRequire('bK0aF'));